var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{on:{"click":_vm.hide}},[(_vm.showTag)?_c('div',{staticClass:"mask fixed l0 t0 r0 b0 rgba5"}):_vm._e(),_vm._v(" "),(_vm.showTag)?_c('div',{staticClass:"main"},[_c('img',{staticClass:"fixed l0",style:(_vm.style),attrs:{"src":_vm.url,"alt":""},on:{"transitionend":_vm.transitionend}})]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-9dbf60c2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/plugins/v-bar-scan.vue
// module id = 1507
// module chunks = 379